/* Hover color change image product */
jQuery(document).ready(function($) {
  jQuery('.ashleyj_select_color a').each(function(){
    jQuery(this).on("mouseover",function(){
      var ashleyImage = jQuery(this).data('ashleyjvariant-img');
      jQuery(this).parents('.ashleyj_grid_parent').find('.ashleyj_find_img img').attr({ src: ashleyImage }); 
      return false;
    });
  });
});